/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  AddMenuReqVO,
  BaseRspVOAddMenuReqVO,
  BaseRspVOBoolean,
  BaseRspVOFormFieldsVO,
  BaseRspVOFormManagerDetailVO,
  BaseRspVOFormSettingsVO,
  BaseRspVOListFieldDetailRspVO,
  BaseRspVOListFormUniqueRuleVO,
  BaseRspVOListGridFieldInfoVO,
  BaseRspVOListGridFieldVO,
  BaseRspVOListJSONObject,
  BaseRspVOListKmRelationsRspVO,
  BaseRspVOListMapStringObject,
  BaseRspVOListMenuTreeNodeVO,
  BaseRspVOLong,
  BaseRspVOObject,
  BaseRspVOPageRspVOFormManagerVO,
  BaseRspVOPageRspVOGridManagerVO,
  BaseRspVOPageRspVOMenuManagerVO,
  BaseRspVOString,
  BusinessRuleVO,
  FieldQueryReqVO,
  FormSettingsReqVO,
  GridFieldVO,
  JSONObject,
  OnBoardReqDTO,
  PageReqVO,
  UniqueValidateRuleVO,
  UpdateFormReqVO,
} from "././index.d.ts";

export class FormManager<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Menu Manager API
   * @name GetMenus
   * @request GET:/form-manager/menus
   */
  getMenus = (
    query: {
      domainName?: string;
      moduleName: string;
      section: string;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
      /**
       * @format int32
       * @default 1
       */
      pageNum?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOPageRspVOMenuManagerVO, any>({
      path: `/form-manager/menus`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name UpdateMenu
   * @request PUT:/form-manager/menus
   */
  updateMenu = (data: AddMenuReqVO, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/menus`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name AddMenu
   * @request POST:/form-manager/menus
   */
  addMenu = (data: AddMenuReqVO, params: RequestParams = {}) =>
    this.http.request<BaseRspVOLong, any>({
      path: `/form-manager/menus`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name ChangeMenuStatus
   * @request PUT:/form-manager/menus/{id}/status
   */
  changeMenuStatus = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/menus/${id}/status`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name MenuReorder
   * @request PUT:/form-manager/menus/{id1}/{id2}
   */
  menuReorder = (id1: number, id2: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/menus/${id1}/${id2}`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name UpdateFormField
   * @request PUT:/form-manager/forms/fields/{id}
   */
  updateFormField = (
    id: number,
    data: JSONObject,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/fields/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name AddFormField
   * @request POST:/form-manager/forms/fields/{id}
   */
  addFormField = (id: number, data: JSONObject, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/fields/${id}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name ExchangeFieldOrder
   * @request PUT:/form-manager/forms/fields/{id}/{fieldId1}/{fieldId2}
   */
  exchangeFieldOrder = (
    id: number,
    fieldId1: number,
    fieldId2: number,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/fields/${id}/${fieldId1}/${fieldId2}`,
      method: "PUT",
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name UpdateFieldBusinessRule
   * @request PUT:/form-manager/forms/fields/business-rule
   */
  updateFieldBusinessRule = (
    data: BusinessRuleVO,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/fields/business-rule`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name OnBoard
   * @request POST:/form-manager/onboard
   */
  onBoard = (data: OnBoardReqDTO[], params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/form-manager/onboard`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name RevertGridToDefault
   * @request POST:/form-manager/grids/{id}/revert
   */
  revertGridToDefault = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOListGridFieldVO, any>({
      path: `/form-manager/grids/${id}/revert`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetGridFields
   * @request GET:/form-manager/grids/{id}/fields
   */
  getGridFields = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOListGridFieldVO, any>({
      path: `/form-manager/grids/${id}/fields`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name UpdateGridFields
   * @request POST:/form-manager/grids/{id}/fields
   */
  updateGridFields = (
    id: number,
    data: GridFieldVO[],
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/grids/${id}/fields`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetForms
   * @request GET:/form-manager/forms
   */
  getForms = (
    query: {
      pageReqVO: PageReqVO;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOPageRspVOFormManagerVO, any>({
      path: `/form-manager/forms`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name UpdateFormSettingsJson
   * @request POST:/form-manager/forms
   */
  updateFormSettingsJson = (
    data: UpdateFormReqVO,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name SetFormUniqueKeys
   * @request POST:/form-manager/forms/unique-key
   */
  setFormUniqueKeys = (
    data: UniqueValidateRuleVO,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/unique-key`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFormSettings
   * @request POST:/form-manager/forms/settings
   */
  getFormSettings = (data: FormSettingsReqVO, params: RequestParams = {}) =>
    this.http.request<BaseRspVOFormSettingsVO, any>({
      path: `/form-manager/forms/settings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name ImportFormFields
   * @request POST:/form-manager/form/fields/import
   */
  importFormFields = (data: JSONObject, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/form/fields/import`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFieldsDetail
   * @request POST:/form-manager/fields/detail
   */
  getFieldsDetail = (data: FieldQueryReqVO[], params: RequestParams = {}) =>
    this.http.request<BaseRspVOListFieldDetailRspVO, any>({
      path: `/form-manager/fields/detail`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFieldsByDomainNameAndModuleName
   * @request GET:/form-manager/module/fields
   */
  getFieldsByDomainNameAndModuleName = (
    query: {
      domainName?: string;
      moduleName: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOListGridFieldInfoVO, any>({
      path: `/form-manager/module/fields`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name GetMenuDetail
   * @request GET:/form-manager/menus/{id}
   */
  getMenuDetail = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOAddMenuReqVO, any>({
      path: `/form-manager/menus/${id}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu Manager API
   * @name GetMenusForModule
   * @request GET:/form-manager/menus/module
   */
  getMenusForModule = (
    query: {
      domain?: string;
      section?: string;
      module: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOListMenuTreeNodeVO, any>({
      path: `/form-manager/menus/module`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetGrids
   * @request GET:/form-manager/grids
   */
  getGrids = (
    query: {
      pageReqVO: PageReqVO;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOPageRspVOGridManagerVO, any>({
      path: `/form-manager/grids`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetGridFields2
   * @request GET:/form-manager/grids/fields
   * @originalName getGridFields
   * @duplicate
   */
  getGridFields2 = (
    query: {
      module: string;
      gridName: string;
      section?: string;
      domain?: string;
      /**
       * Field setting items of field json, multiple items split by comma.
       * if request with items, will response these settings as additional attributes(notice attribute's data type following field json),
       */
      items?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOListMapStringObject, any>({
      path: `/form-manager/grids/fields`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFormFields
   * @request GET:/form-manager/forms/{id}/fields
   */
  getFormFields = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOFormFieldsVO, any>({
      path: `/form-manager/forms/${id}/fields`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFormUniqueKeys
   * @request GET:/form-manager/forms/unique-key/{formId}
   */
  getFormUniqueKeys = (formId: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOListFormUniqueRuleVO, any>({
      path: `/form-manager/forms/unique-key/${formId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name GetFormField
   * @request GET:/form-manager/forms/fields/{id}/{fieldId}
   */
  getFormField = (id: number, fieldId: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOObject, any>({
      path: `/form-manager/forms/fields/${id}/${fieldId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name DeleteFormField
   * @request DELETE:/form-manager/forms/fields/{id}/{fieldId}
   */
  deleteFormField = (id: number, fieldId: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/forms/fields/${id}/${fieldId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags Field Manager API
   * @name GetFieldBusinessRule
   * @request GET:/form-manager/forms/fields/{id}/{fieldId}/business-rule
   */
  getFieldBusinessRule = (
    id: number,
    fieldId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOListJSONObject, any>({
      path: `/form-manager/forms/fields/${id}/${fieldId}/business-rule`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetBusinessFields
   * @request GET:/form-manager/form/business-fields
   */
  getBusinessFields = (
    query: {
      module: string;
      formName: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOString, any>({
      path: `/form-manager/form/business-fields`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetBusinessFields2
   * @request GET:/form-manager/form/business-fields/{formId}
   * @originalName getBusinessFields
   * @duplicate
   */
  getBusinessFields2 = (formId: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOListJSONObject, any>({
      path: `/form-manager/form/business-fields/${formId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetFormDetail
   * @request GET:/form-manager/form-detail
   */
  getFormDetail = (
    query: {
      domainName?: string;
      moduleName: string;
      section?: string;
      menu: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOFormManagerDetailVO, any>({
      path: `/form-manager/form-detail`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name GetRelationsByConceptName
   * @request GET:/form-manager/concept/relations
   */
  getRelationsByConceptName = (
    query: {
      conceptName: string;
      module: string;
      tenantId: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BaseRspVOListKmRelationsRspVO, any>({
      path: `/form-manager/concept/relations`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form Manager API
   * @name DeleteForm
   * @request DELETE:/form-manager/form/{id}
   */
  deleteForm = (id: number, params: RequestParams = {}) =>
    this.http.request<BaseRspVOBoolean, any>({
      path: `/form-manager/form/${id}`,
      method: "DELETE",
      ...params,
    });
}
